var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import variantColorMap from 'pxc-editor-core/constants/variantColorMap';
import { colors } from '@/globalStyles';
import { ENDLESS_PAGE_MINIMUM_LENGTH_MM } from '../constants';
export var parse = function (material) {
    var general = material.general, _a = material.geometry, _b = _a.page, box = _b.box, solid = _b.solid, holes = _b.holes, decorations = _b.decorations, endless = _a.endless, unparsedLayouts = material.layouts, variants = material.variants, printParameters = material.print_parameters;
    var holeShapes = holes.map(mapShapeData('hole'));
    var solidShapes = solid.map(mapShapeData('solid'));
    var decorationShapes = decorations.map(mapShapeData('decoration'));
    var layouts = unparsedLayouts.map(function (layout) {
        var unparsedGroups = layout.groups, shields_dictionary = layout.shields_dictionary, name = layout.name;
        var groups = unparsedGroups.map(function (group) {
            var group_color = group.group_color, unparsedShields = group.shields, id = group.id, text_style = group.text_style, _a = group.active_color_mode, active_color_mode = _a === void 0 ? '' : _a, _b = group.inactive_color_mode, inactive_color_mode = _b === void 0 ? '' : _b;
            var shields = [];
            unparsedShields.forEach(function (shield) {
                var position = shield.position, shield_definition_id = shield.shield_definition_id, shield_id = shield.id;
                var shieldTemplate = shields_dictionary.find(function (s) { return s.id === shield_definition_id; });
                if (shieldTemplate) {
                    var res = mapShapeData('shield')(shieldTemplate.solid);
                    res.position = position;
                    res.shield_definition_id = shield_definition_id;
                    res.shield_id = shield_id;
                    shields.push(res);
                }
            });
            return { group_color: group_color, shields: shields, id: id, text_style: text_style, active_color_mode: active_color_mode, inactive_color_mode: inactive_color_mode };
        });
        return { groups: groups, shields_dictionary: shields_dictionary, name: name };
    });
    var fixedEndless = endless;
    if (endless && fixedEndless) {
        fixedEndless.length = __assign(__assign({}, endless.length), { minimum: ENDLESS_PAGE_MINIMUM_LENGTH_MM });
    }
    return __assign({ endless: fixedEndless, box: box, solid: solidShapes, holes: holeShapes, decorations: decorationShapes, layouts: layouts, variants: variants, printParameters: printParameters }, general);
};
var mapPrimitiveData = function (data) {
    var id = data.id, primitive_type = data.primitive_type, printable = data.printable, restProps = __rest(data, ["id", "primitive_type", "printable"]);
    var primitiveType = Object.getOwnPropertyNames(restProps)[0];
    return {
        primitiveType: primitiveType,
        primitiveProps: restProps[primitiveType],
        printable: !!printable,
    };
};
var mapShapeData = function (logicalType) { return function (shape) {
    var res = mapPrimitiveData(shape.hasOwnProperty('contour') ? shape.contour : shape);
    res.logicalType = logicalType;
    return res;
}; };
export var isMultiColored = function (printParameters, innerMaterial) {
    if (printParameters) {
        return printParameters.color_output_mode !== 'MONO';
    }
    else if (innerMaterial) {
        return innerMaterial.printParameters.color_output_mode !== 'MONO';
    }
    return false;
};
export var getVariantPaperColor = function (variant) {
    if (variant === null || variant === void 0 ? void 0 : variant.background_color_hex) {
        return variant.background_color_hex;
    }
    return variantColorMap[variant.background_color];
};
export var getColorByVariantPaperColor = function (variant) {
    if (variant) {
        var hexColor = getVariantPaperColor(variant);
        if (hexColor) {
            return hexColor;
        }
    }
    return colors.transparent;
};
export var getVariantRibbonColor = function (variant) {
    if (variant === null || variant === void 0 ? void 0 : variant.ribbon_color) {
        return variant.ribbon_color;
    }
    else if (variant === null || variant === void 0 ? void 0 : variant.article_name) {
        var regex = /[-/]WH$/g;
        var match = variant.article_name.match(regex);
        if (match) {
            var _a = __read(match, 1), colors_1 = _a[0];
            if (colors_1) {
                var ribbonColor = colors_1.split('/')[1] || colors_1.split('-')[1];
                if (ribbonColor) {
                    return ribbonColor;
                }
            }
        }
    }
};
export var getColorByVariantRibbonColor = function (variant) {
    var variantColor = getVariantRibbonColor(variant);
    if (variantColor && variantColorMap[variantColor]) {
        return variantColorMap[variantColor];
    }
    return colors.black;
};
export var getMaterialType = function (material) {
    return material.general.type;
};
